import { getResourceApiKeys } from 'js/lib/ResourceUtils';
import { useSelector } from 'react-redux';

export function useResourceApiKey(sourceId: string) {
  const apiKeys = useSelector((state: any) => state.entities.apiKeys);
  const source = useSelector((state: any) => state.entities.sources[sourceId]);
  const sourceApiKeys = getResourceApiKeys(source, apiKeys);
  const sourceApiKey = Object.values(sourceApiKeys)[0] as any;

  return sourceApiKey;
}
